<template>
  <div class="section-swiper__controls">
    <Icon
      id="arrow-btn"
      class="section-swiper__controls-btn -reverse"
      :class="{ '-disabled': cannotPrev }"
      @click="swiper.slidePrev()"
    />
    <Icon
      id="arrow-btn"
      class="section-swiper__controls-btn"
      :class="{ '-disabled': cannotNext }"
      @click="swiper.slideNext()"
    />
  </div>
</template>

<script>
import { useSwiper } from 'swiper/vue'
export default {
  name: 'SwiperControls',
  props: {
    slidesPerView: {
      Type: Number,
      default: 2,
    },
  },
  setup() {
    const swiper = useSwiper()
    return {
      swiper,
    }
  },
  computed: {
    cannotNext() {
      return this.swiper.activeIndex === this.swiper.slides.length - this.slidesPerView
    },
    cannotPrev() {
      return this.swiper.activeIndex === 0
    },
  },
}
</script>
